import React from 'react';
import LastaTemplate from '@Containers/MainScreen/LastaTemplate';
import DefaultTemplate from '@Containers/MainScreen/DefaultTemplate';
import PropTypes from 'prop-types';
import OldTemplate from '@Containers/MainScreen/OldTemplate';

const MainScreen = ({ variant = '' }) => {
  switch (variant) {
    case 'lasta':
      return <LastaTemplate />;
    case 'oldTemplate':
      return <OldTemplate />;
    default:
      return <DefaultTemplate />;
  }
};
export default MainScreen;

MainScreen.propTypes = {
  variant: PropTypes.string,
};
